import { Component, OnInit, ViewChild } from '@angular/core';
import { Constants } from '../../../constants/constants';
import { TranslateService } from '@ngx-translate/core';
import { EntidadDTO } from '../../tramites/models/entidadDTO';
import { TramiteService } from '../../../services/tramite.service';
import { CrearEventoEntidadDto } from '../../../dto/eventos/evento-entidad.dto';
import { combineLatest } from 'rxjs';
import { DataUsuario } from '../../configuracion-cuenta/dto/data-usuarioDTO';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormField } from '../../../dto/util/form-field';
import { ModalGestionEventosEntidadComponent } from './modal-gestion-eventos-entidad/modal-gestion-eventos-entidad.component';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { EventosEntidadService } from '../services/eventos-entidad.service';

declare var $: any; // Importar jQuery si es necesario
@Component({
  selector: 'app-gestion-eventos-entidad',
  templateUrl: './gestion-eventos-entidad.component.html',
  styleUrls: ['./gestion-eventos-entidad.component.scss']
})
export class GestionEventosEntidadComponent implements OnInit {

  @ViewChild(ModalGestionEventosEntidadComponent)
  modalGestionEventosEntidadComponent!: ModalGestionEventosEntidadComponent;
  idEntidad!: number;
  // Multilenguaje
  gestionEventoText: any = {};
  comunText: any = {};
  // Entidades
  entidades: EntidadDTO[] = [];
  // lista eventos
  eventos: CrearEventoEntidadDto[] = [];
  // variable para mostrar todos los eventos
  mostrarTodos = false;
  //Cantidad de eventos visibles
  cantidadEventos = Constants.EVENTOS_VISIBLES_ENTIDAD;
  // Contador de eventos visibles
  eventosVisibleCount = Constants.EVENTOS_VISIBLES_ENTIDAD;

  dataUsuario!: DataUsuario;
  // Modal
  fieldsModal: FormField[] = [];

  formEventoEntidad!: FormGroup;

  constructor(
    private translate: TranslateService,
    private readonly tramiteService: TramiteService,
    private readonly fb: FormBuilder,
    private readonly eventosService: EventosEntidadService,
    private readonly alertaModalService: AlertaModalService

  ) {
    this.listaEntidades();
  }

  ngOnInit(): void {
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_TYPE) ?? '{}'
    );
    // Se obtiene el ID de la entidad desde la sesión
    this.idEntidad = infoInicioSesion.Id_Entidad;
    this.getListaEventosEntidad();
    combineLatest({
      gestionEvento: this.translate.stream('gestion-evento-entidad'),
      comun: this.translate.stream('comun'),
    }).subscribe(({ gestionEvento, comun }) => {
      // Asignar traducciones a variables
      this.gestionEventoText = gestionEvento;
      this.comunText = comun;
    });

  }



  // Método para listar entidades
  listaEntidades() {
    // Se consume el servicio de listar entidades
    this.tramiteService.listaEntidadesYTramites().subscribe(resp => {
      this.entidades = resp;
    });
  }

  // Listas
  getListaEventosEntidad() {
    this.eventosService.listarEventosActivos(this.idEntidad).subscribe({
      next: (response) => {
        this.eventos = response;
      },
      error: (error) => {
        // Manejar el error
      }
    });
  }

  cargarListas(flag: boolean) {
    if (flag) this.getListaEventosEntidad();
  }

  getFormatHora(fechaHora: string): string {
    const fecha = new Date(fechaHora);

    return fecha.toLocaleTimeString('es-CO', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  }

  // Método para obtener el nombre de la entidad
  getNombreEntidad(idEntidad: number): string {
    return this.entidades.find(entidad => entidad.Id === idEntidad)?.Entidad || '';
  }

  get eventosMostrados() {
    return this.eventos.slice(0, this.eventosVisibleCount);
  }

  verMas() {
    if (this.eventosVisibleCount < this.eventos.length) {
      this.eventosVisibleCount += 3;
    } else {
      // vuelve al inicio si ya se mostraron todos
      this.eventosVisibleCount = this.cantidadEventos;
    }
  }

  // Verifica si hay algún evento seleccionado
  get haySeleccionados(): boolean {
    return this.eventos.some(e => e.seleccionado);
  }

  // Actualiza el estado de selección
  toggleSeleccion(evento: CrearEventoEntidadDto, event: any) {
    evento.seleccionado = event.target.checked;
  }

  get cantidadSeleccionados(): number {
    return this.eventos.filter(e => e.seleccionado).length;
  }

  isLink(evento: CrearEventoEntidadDto): boolean {
    const lugar = evento.Lugar?.toLowerCase() || '';
    return lugar.startsWith('http://') || lugar.startsWith('https://');
  }

  get eventosSeleccionados(): CrearEventoEntidadDto[] {
    return this.eventos.filter(e => e.seleccionado);
  }

  editarEvento() {
    const eventoSeleccionado = this.eventosSeleccionados[0];
    this.modalEditar(eventoSeleccionado);
  }

  modalEditar(evento: CrearEventoEntidadDto) {
    this.modalGestionEventosEntidadComponent.abrirConDatos(evento);
  }

  modalVer() {
    this.modalGestionEventosEntidadComponent.limpiarFormulario();
    this.modalGestionEventosEntidadComponent.abrirModal(false);
  }

  onSubmitFormulario(event: FormGroup): void {
    this.formEventoEntidad = event;
  }

  onSubmitEvento($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
  }

  abrirModalBorrar() {
    this.modalGestionEventosEntidadComponent.abrirModalBorrar();
  }
}
